/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { Route, Routes, useLocation } from 'react-router-dom';
import {
  FORGOT_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  NEW_PASSWORD_ROUTE,
  REGISTER_ROUTE,
  SUCCESS_ROUTE,
  TERMS_AND_CONDITONS_ROUTE,
} from './constants/RouteNameConstants';
import Layout from './features/Layout';
import RouterSet from './features/Router';
import history from './features/history';
import ForgotPassword from './modules/authentication/ForgotPassword/component/ForgotPassword';
import Login from './modules/authentication/Login/component/Login';
import NewPassword from './modules/authentication/NewPassword/component/NewPassword';
import Register from './modules/authentication/Register/Register';
import Success from './modules/authentication/Success/Success';
import TermsAndConditions from './modules/authentication/TermsAndConditions/TermsAndConditions';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'react-circular-progressbar/dist/styles.css';
import useGoogleAnalytics from './hook/useGoogleAnalytics';

// Custom hook to update tab title dynamically
export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title; // Update the browser tab title
  }, [title, useLocation()]);
};

function App() {
  useGoogleAnalytics();
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('hide.bs.modal', function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    });
  });

  return (
    <span>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
      <RouterSet history={history}>
        <Routes>
          <Route path={LOGIN_ROUTE} exact element={<Login />} />
          <Route path={REGISTER_ROUTE} exact element={<Register />} />
          <Route path={TERMS_AND_CONDITONS_ROUTE} exact element={<TermsAndConditions />} />
          <Route path={SUCCESS_ROUTE} exact element={<Success />} />
          <Route path={FORGOT_PASSWORD_ROUTE} exact element={<ForgotPassword />} />
          <Route path={NEW_PASSWORD_ROUTE} exact element={<NewPassword />} />
          <Route path={'/*'} element={<Layout />} />
        </Routes>
      </RouterSet>
    </span>
  );
}

export default App;
